import * as React from "react";
import { SidePadder } from "kanopi-components/SpaceWrapper/SidePadder";
import { Placeholder } from "kanopi-components/Placeholder";
import { PaymentMethodCard } from "kw/components/PaymentMethod/PaymentMethodCard";
import { usePolicy } from "kw/policies/hooks/usePolicy";
import { PaymentGateway } from "kw/api/zeus";
import { ParagraphSmall } from "baseui/typography";

type PolicyPaymentMethodPageProps = {
  policyId?: string;
};
const PolicyPaymentMethodPage: React.FC<PolicyPaymentMethodPageProps> = ({
  policyId,
}) => {
  const [policy, { policyLoading }] = usePolicy(policyId);
  const paymentGateway = policy?.riskProfile?.quotes?.[0].product?.paymentGateway;
  const allowUpdatePaymentMethod = paymentGateway === PaymentGateway.STRIPE;

  return (
    <SidePadder padding="flow">
      <Placeholder loading={!policy || policyLoading}>
        {allowUpdatePaymentMethod ? (
          <PaymentMethodCard policyId={policyId} />
        ) : (
          <ParagraphSmall>
            Payment method cannot be viewed or updated for this policy.
          </ParagraphSmall>
        )}
      </Placeholder>
    </SidePadder>
  );
};

export { PolicyPaymentMethodPage };
